


































































import { Component, Mixins, Vue } from "vue-property-decorator";
import {
  URL_PARAM_TOKEN,
  URL_PARAM_COURSE,
  URL_PARAM_TYPE,
  URL_PARAM_TRAN_SRC,
} from "@/utils/url";
import { getCourses, Courses, COURSE_APPLY_STATE } from "@/apis";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import CurrentPoint from "@/components/CurrentPoint.vue";
import TextLabel from "@/components/TextLabel.vue";
import Overlay from "@/components/Overlay.vue";
import SettingMixin from "@/mixins/settingMixin";
import ExpansionPanels from "@/components/ExpansionPanels.vue";

@Component({
  components: {
    ContainImage,
    ImageButton,
    CurrentPoint,
    TextLabel,
    ExpansionPanels,
    Overlay,
  },
})
export default class CollabCourses extends Mixins(Vue, SettingMixin) {
  courses: Courses[] = [];
  ownedCount: number | null = null;

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    const isWin = await this.checkIsWin();
    if (isWin) return;
    // postActionLog(this.campaignId, "apply_view", this.token);
    await this.getCourses();
    return;
  }

  async getCourses(): Promise<void> {
    try {
      const res = await getCourses(this.campaignId, this.token);
      const courseGroup = res.data.course_groups.find(
        (cg) => cg.id === this.collabCourseGroupId
      ) ?? { courses: [] };
      this.courses = courseGroup.courses;
      this.ownedCount = res.data.owned_count;
    } catch (e) {
      this.routerPushSystemErrorPage();
    }
  }

  isActive(course: Courses): boolean {
    return course.course_apply_state === COURSE_APPLY_STATE.ApplyOk;
  }

  get collabCourseGroupId(): number {
    return this.courseGroupEnv.collab.id;
  }

  get collaboPageGoToTopPage(): string {
    return this.config.imageName.collabCourses?.collaboPageGoToTopPage
      ? `./images/campaign/${this.config.imageName.collabCourses.collaboPageGoToTopPage}`
      : "";
  }

  get collaboCourseHeader(): string {
    return this.config.imageName.collabCourses?.collaboCourseHeader
      ? `./images/campaign/${this.config.imageName.collabCourses.collaboCourseHeader}`
      : "";
  }

  productActiveImage(id: number): string {
    return this.courseImageNameEnv[id].active
      ? `./images/campaign/${this.courseImageNameEnv[id].active}`
      : "";
  }

  productInactiveImage(id: number): string {
    return this.courseImageNameEnv[id].inactive
      ? `./images/campaign/${this.courseImageNameEnv[id].inactive}`
      : "";
  }

  get courseText(): string {
    return this.config.courseText;
  }

  routerPushRequestDetailPage(id?: number): void {
    this.pushWithTransition(() => {
      this.$router.push({
        name: "RequestDetail",
        query: {
          [URL_PARAM_TOKEN]: this.token,
          [URL_PARAM_COURSE]: String(id),
          [URL_PARAM_TYPE]: "inKind",
          [URL_PARAM_TRAN_SRC]: this.transitionSrc,
        },
      });
    });
  }
}
